import React, {Component} from 'react'
import { Form, Grid } from 'semantic-ui-react';

import Mensagem from './../components/Mensagem';

export class Step3 extends Component {

    render() {   

        if (this.props.currentStep !== 3) {
            return null
        }         

        return (
            <Grid textAlign='center' style={{ height: '100vh', marginTop: '0px' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450, width: '90vw' }}>
                    <Form size='large'>
                        <Mensagem 
                        sucesso={this.props.sucesso}
                        newPage={this.props.newPage}
                        defaultPage={this.props.defaultPage}
                        acao={this.props.acao}
                        />
                    </Form>                   
                </Grid.Column>
            </Grid>
        )
    }
}


export default Step3;